import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import { singleIndex as singleIndexMapping } from "instantsearch.js/es/lib/stateMappings";

import searchBox from "./searchBox";
import articles from "./articles";
import configuration from "./configuration";

const searchClient = algoliasearch(
  process.env.MIX_ALGOLIA_APP_ID,
  process.env.MIX_ALGOLIA_SEARCH_ONLY
);

const search = instantsearch({
  searchClient,
  indexName: "paragraphs_index",
  routing: {
    stateMapping: singleIndexMapping("paragraphs_index")
  }
});

search.addWidgets([searchBox, configuration, articles]);

window.$copy = require("copy-to-clipboard");

search.start();
